import listViewStore from '../store/Store';
/* When comparing an message's parentFolderId with a tableView's folder id,
a group needs to use its serverFolderId for comparison */
export default function getFolderIdForParentComparison(tableViewId) {
    var tableView = listViewStore.tableViews.get(tableViewId);
    switch (tableView.tableQuery.type) {
        case 2 /* Group */:
            return tableView.serverFolderId;
        case 0 /* Folder */:
            return tableView.tableQuery.folderId;
        case 1 /* Search */:
            return null;
    }
}
//# sourceMappingURL=getFolderIdForParentComparison.js.map